
import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faFileExcel,
} from '@fortawesome/free-solid-svg-icons';

import Protected from 'component/Protected';
import Loading from 'component/Loading';
import ModalScreen from 'component/ModalScreen';

import API from 'service/api';
import Util from 'service/util';

import Calendar from 'component/calendar/Calendar';
import moment from 'moment';
import NoData from 'component/NoData';

const LocationScheduleDayTable = ({events}) =>
{
  return (
    <table className="table-sc-service">
      <thead>
        <tr>
          <th className="plan"    >計劃</th>
          <th className="license" >車牌</th>
          <th className="floor"   >樓層</th>
          <th className="psn"     >車位</th>
          <th className="waxing"  >打蠟</th>
          <th className="worker"  >負責工人</th>
          <th className="remarks" >備註</th>
        </tr>
      </thead>
      <tbody>
      { events.map(ev =>
        <tr key={ev.id} className="sc-service-item">
          <td className="plan"    >{ ev.srv_plan   }</td>
          <td className="license" >{ ev.cd_license }</td>
          <td className="floor"   >{ ev.srv_floor  }</td>
          <td className="psn"     >{ ev.srv_psn    }</td>
          <td className="waxing"  >
            { !ev.waxing?'': <FontAwesomeIcon icon={faCheck} /> }
          </td>
          <td className="worker" title={ev.worker} >{ ev.worker_name }</td>
          <td className="remarks">{ ev.remarks }</td>
        </tr>
      )}
      </tbody>
    </table>
  );
}

const LocationScheduleViewContent = ({location, schedules}) =>
{
  const [modal, setModal] = useState(null);
  const [modalTitle, setModalTitle] = useState('');

  // ----------------------------------------------------
  // functions
  const showDayEventModal = (date, events) => {
    let modal;

    if (!events?.length) {
      modal = <NoData />;
    } else {
      modal = (<>
        <div className="action-panel">
          <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_NIGHT']}>
            <button className="btn dark-green btn-export" onClick={e=>exportXls(date)}>
              <FontAwesomeIcon icon={faFileExcel} />
              <span> 匯出本日行程</span>
            </button>
          </Protected>
        </div>
        <LocationScheduleDayTable events={events} />
      </>);
    }

    setModal(modal);

    let locName = `${location.srv_dis}${location.srv_loc} ${location.name_zh} ${location.name_en}`;
    setModalTitle(`${locName} 服務行程 (${moment(date).format('DD/MM/YYYY')})`);
  }

  const closeModal = () => {
    setModal(null);
  }

  const exportXls = (date) =>
  {
    const [dis, loc] = [location.srv_dis, location.srv_loc];
    const ix_date = moment(date).format('YYYYMMDD');
    API.exportLocationSchedule(dis, loc, date).then(resp =>
      Util.download(resp, `${dis}${loc}工作日程_${ix_date}.xlsx`)
    );
  } // export xls

  // ----------------------------------------------------
  // render
  if (!schedules) return <Loading />

  return (<>
    <div>
      <Calendar events={schedules} onClickDay={showDayEventModal}/>
    </div>
    <ModalScreen title={modalTitle} show={!!modal} onClose={closeModal}>
      {modal}
   </ModalScreen>
  </>);

}

export default LocationScheduleViewContent;
